import { useNavigate } from "react-router-dom";
import { useGetcomplainUserAppQuery } from "./complainUserAppSlice";
import { useRef, useState } from "react";
import ComplainUserAppEdit from './ComplainUserAppEdit';

function ComplainUserAppList() {
    const [editData, setEditData] = useState({});

    const {
        data: complainUserApp
    } = useGetcomplainUserAppQuery();

    console.log("complainUserApp",complainUserApp);
    

    const navigate = useNavigate();

    const refOpen = useRef();
    const editCleaner = (ID) => {
        refOpen.current.click()
        const data = complainUserApp?.entities?.undefined?.find(item => item.id === ID);
        setEditData({
            id: data?.id,
            status: data?.status,
            remark: data?.remark
        })
    };

    return (
        <div className='container-fluid '>
            <div className="d-flex justify-content-end mt-5 ml-4 mb-2">
                <div className="text-right">
                </div>
            </div>
            <div>
                <div className='box_overflow col'>
                    <table className='border table p-2'>
                        <thead className='mobile-hidden'>
                            <tr className='bg-left-navabr '>
                                <th className='text-light'>#</th>
                                <th className='text-light'>Name</th>
                                <th className='text-light'>Number</th>
                                <th className='text-light'>Complain</th>
                                <th className='text-light'>Status</th>
                                <th className='text-light'>	Action</th>
                            </tr>
                        </thead>
                        <tbody className='mobile-hidden'>
                            {complainUserApp?.entities?.undefined?.map((complaint, index) => (
                                <tr className='listData'
                                    key={complaint.id}
                                >
                                    <td onClick={() => (navigate(`/b2g/ComplainUserAppDetail/${complaint?.id}`))}>{index + 1}</td>
                                    {/* <td>{index + 1}</td> */}
                                    <td onClick={() => (navigate(`/b2g/ComplainUserAppDetail/${complaint?.id}`))}>{complaint.u_name}</td>
                                    <td onClick={() => (navigate(`/b2g/ComplainUserAppDetail/${complaint?.id}`))}>{complaint.u_number}</td>
                                    <td onClick={() => (navigate(`/b2g/ComplainUserAppDetail/${complaint?.id}`))}>{complaint.complain_text}</td>
                                    <td onClick={() => (navigate(`/b2g/ComplainUserAppDetail/${complaint?.id}`))}>{complaint.status}</td>
                                    <td>
                                        <div className="dropdown">
                                            <button
                                                className="btn dropdown-toggle p-2"
                                                type="button"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                style={{ border: 'none' }}
                                            >
                                                <i className="fas fa-ellipsis-v" style={{ color: 'gray' }}></i>
                                            </button>
                                            <ul className="dropdown_Box dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <div
                                                        className="dropdown-item"
                                                        onClick={() => editCleaner(complaint?.id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        Edit
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
              <ComplainUserAppEdit
                refOpen={refOpen}
                setEditData={setEditData}
                editData={editData}
            />
        </div>
    );
}

export default ComplainUserAppList;
